'use strict';

angular.module('atex.dam').factory('DownloadService', [ '$http', '$q','ContentService', 'FileService', 'AuthenticationService',
                                                        function($http, $q, ContentService, FileService, AuthenticationService) {

  function download(data, contentType, filename) {
    return $q(function(resolve, reject) {
      var blob, url;
      if (navigator.msSaveBlob) {
        blob = new Blob([ data ], {
          type : contentType
        });
        navigator.msSaveBlob(blob, filename);
      } else {
        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;

        if (urlCreator) {
          var link = document.createElement("a");

          if ("download" in link) {
            blob = new Blob([ data ], {
              type : contentType
            });
            url = urlCreator.createObjectURL(blob);

            link.setAttribute("href", url);
            link.setAttribute("download", filename);

            var event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
            link.dispatchEvent(event);
          } else {
            blob = new Blob([ data ], {
              type : contentType
            });
            url = urlCreator.createObjectURL(blob);
            location.href = url;
          }
        }
      }

      resolve(true);
    });
  }

  var types = {};

  return {
    loadTypes : function() {
      
      var article = {};
      article['fields'] = 'headline,body,author';
      article['ext'] = '.txt';
      
      types['p.DamArticle'] = article;
      
      return types;
    },

    getTypes : function() {
      return types;
    },

    text : function(data, name) {
      return $q(function(resolve, reject) {
        download(data, 'text/plain', name, undefined).then(function(e) {
          resolve(e);
        });
      });
    },

    binary : function(contentId) {
      return $q(function(resolve, reject) {

        var transferInfo = { id : contentId};
        return ContentService.getContent(transferInfo).then(function(responseInfo) {

          var fileUri, ext;
          if(responseInfo.data.aspects['atex.Image']){
            // In case of Image we start from atex.Image aspect to retrieve the source path from atex.Files
            var fileName = responseInfo.data.aspects['atex.Image'].data.filePath;
            fileUri = responseInfo.data.aspects['atex.Files'].data.files[fileName].fileUri;
            ext = atex.dam.AngularUtils.getFileExtension(fileName);
          } else if (responseInfo.data.aspects['atex.Files'] && responseInfo.data.aspects['atex.Files'].data.files) {
            // otherwise get the required source high res from atex.Files
            for (var property in responseInfo.data.aspects['atex.Files'].data.files) {
              if (responseInfo.data.aspects['atex.Files'].data.files.hasOwnProperty(property)) {
                if (responseInfo.data.aspects['atex.Files'].data.files[property].fileUri) {
                  fileUri = responseInfo.data.aspects['atex.Files'].data.files[property].fileUri;
                  ext = atex.dam.AngularUtils.getFileExtension(property);
                  break;
                }
              }
            }
          } else {
            console.log("DownloadService.binary: No atex.Files available!");
            reject();
          }

          if (responseInfo.data.aspects.contentData.data.objectType === 'video' &&
            responseInfo.data.aspects.contentData.data.videoPath !== undefined && responseInfo.data.aspects.contentData.data.videoPath.length > 0){
            var uri = responseInfo.data.aspects.contentData.data.videoPath.substring(0, responseInfo.data.aspects.contentData.data.videoPath.lastIndexOf("/"));
            var name = uri.substring(uri.lastIndexOf("/")+1);
						var xhr = new XMLHttpRequest();
						xhr.open('GET', uri, true);
						xhr.responseType = 'blob';
						xhr.onload = function () {
							var urlCreator = window.URL || window.webkitURL;
							var imageUrl = urlCreator.createObjectURL(this.response);
							var tag = document.createElement('a');
							tag.href = imageUrl;
							tag.target = '_blank';
							tag.download = name;
							document.body.appendChild(tag);
							tag.click();
							document.body.removeChild(tag);
              resolve(true);
						};
						xhr.send();
          }else{
            if (!fileUri) {
              console.log("DownloadService.binary: No fileUri detected!");
              reject();
            }

            var fInfo = {uri: fileUri};

            var downloadVar = FileService.getFileAsBlob(fInfo).whenCompleted().then(function(response) {
              var contentType = "application/octet-stream";
              var name = contentId;
              if (ext) {
                name = name + '.' + ext;
              }
              download(response.data, contentType, name).then(function(e) {
                resolve(e);
              });
            });
          }
          
        });
      });
    }
    
  };
} ]);
